import type { ReactNode } from 'react';

import { MessageRow } from './MessageRow.tsx';

export const ArtifactCard = ({
	icon,
	title,
	description,
	onClick,
}: {
	icon: ReactNode;
	title: string;
	description: string;
	onClick: () => void;
}) => {
	return (
		<MessageRow>
			<button
				type="button"
				onClick={onClick}
				className="flex w-full cursor-pointer items-center gap-3 rounded-lg
					border border-gray-200 bg-white p-4 shadow-sm transition-colors
					hover:bg-gray-50"
			>
				<div
					className="flex size-10 shrink-0 items-center justify-center
						text-gray-600"
				>
					{icon}
				</div>
				<div className="flex flex-1 flex-col items-start text-left">
					<span className="text-base font-semibold text-gray-900">{title}</span>
					<span className="line-clamp-4 text-sm text-gray-500">
						{description}
					</span>
				</div>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 20 20"
					fill="currentColor"
					className="size-5 shrink-0 text-gray-400"
				>
					<path
						fillRule="evenodd"
						d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
						clipRule="evenodd"
					/>
				</svg>
			</button>
		</MessageRow>
	);
};
